module.exports = __webpack_public_path__ + "static/media/施工前.a65422f4.jpg";